module.exports = __webpack_public_path__ + "img/controller-ps3.5f632266.png";